module.exports = __webpack_public_path__ + "static/media/5_2.56c701d4.png";